import {
  Alert,
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { addNewOrder as onAddNewOrder } from "../../slices/thunks";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { getLoggedinUser } from "../../utils/StorageManager";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../../utils/Formater";
import UpgradeModal from "../../Components/Common/UpgradeModal";

export default function PlaceOrder(props) {
  const dispatch = useDispatch();
  const [showPlaceOrder, setShowPlaceOrder] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [orderQuantity, setOrderQuantity] = useState(0);
  const userProfileSession = getLoggedinUser();
  const navigate = useNavigate();
  const [stepsQuantity, setStepsQuantity] = useState([]);
  
  // Check if user has free trial
  const hasFreeTrialPlan = userProfileSession?.user_freeType === "trial";
  const onPlaceOrder = () => {
    if (
      orderQuantity < props.selectedProduct.pro_minBuy ||
      orderQuantity > props.selectedProduct.pro_maxBuy
    ) {
      toast.error(
        "Order quantity should be between min and max order quantity"
      );
      return;
    } else {
      dispatch(
        onAddNewOrder({
          pro_id: props.selectedProduct.pro_id,
          quantity: Number(orderQuantity),
        })
      );
      setShowPlaceOrder(false);
    }
  };

  useEffect(() => {
    setShowPlaceOrder(props.open);
    setAcknowledged(false);
    const steps = [];
    for (
      let i = props.selectedProduct?.pro_minBuy;
      i <= props.selectedProduct?.pro_maxBuy;
      i += props.selectedProduct?.pro_minBuy
    ) {
      steps.push(i);
    }
    setStepsQuantity(steps);
  }, [props.open]);

  useEffect(() => {
    if (!showPlaceOrder) {
      setAcknowledged(false);
      props.onClose();
    }
  }, [showPlaceOrder]);

  useEffect(() => {
    setOrderQuantity(props.selectedProduct?.pro_minBuy);
  }, [props.selectedProduct]);

  const [acknowledged, setAcknowledged] = useState(false);

  const handleAcknowledgement = (e) => {
    setAcknowledged(e.target.checked);
  };

  return (
    <>
      <UpgradeModal 
        isOpen={showUpgradeModal} 
        toggle={() => setShowUpgradeModal(false)} 
      />
      <Modal
        isOpen={showPlaceOrder}
        toggle={() => setShowPlaceOrder(!showPlaceOrder)}
        onClosed={() => setShowPlaceOrder(false)}
        size="lg"
      >
        <Modal
        isOpen={showConfirm}
        toggle={() => setShowConfirm(!showConfirm)}
        centered={true}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Confirm Order</h5>
          <button
            onClick={() => setShowConfirm(false)}
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 ">
            <lord-icon
              src="https://cdn.lordicon.com/gsqxdxog.json"
              trigger="loop"
              colors="primary:#f7b84b,secondary:#f06548"
              style={{ width: "100px", height: "100px" }}
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15">
              <p className="text-muted mb-0">
                <h5>Are you sure to place this order? </h5>
              </p>
            </div>
            <br />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn w-sm btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setShowConfirm(false)}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn w-sm btn-success "
              id="send-record"
              onClick={() => {
                onPlaceOrder();
              }} // This is the function that will be called when the button is clicked
            >
              Yes, Place it!
            </button>
          </div>
        </ModalBody>
      </Modal>
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="placeOrder">
          Place Order
        </h5>
        <button
          type="button"
          onClick={() => setShowPlaceOrder(false)}
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <div className="d-flex m-1">
          <p className="me-2 h4">
            <b>{props.selectedProduct?.pro_name}</b>
          </p>
        </div>

        {props.selectedProduct?.pro_minBuy ===
        props.selectedProduct?.pro_maxBuy ? (
          <Col lg={4} sm={12}>
            <div className="p-2 border border-dashed rounded">
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-2">
                  <div className="avatar-title rounded bg-transparent text-success fs-24">
                    <i className="ri-stack-fill"></i>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="text-muted mb-1"> Order quantity:</p>
                  <h5 className="mb-0">{props.selectedProduct?.pro_minBuy}</h5>
                </div>
              </div>
            </div>
          </Col>
        ) : (
          <>
            <div className="d-flex m-1">
              <p className="me-2 mt-3">
                {" "}
                <b>Select order quantity:</b>
              </p>

              <select
                className="form-select"
                name="orderQuantity"
                label="Order Quantity"
                onChange={(e) => {
                  setOrderQuantity(e.target.value);
                }}
                value={orderQuantity}
                id="orderQuantity"
                style={{ width: "100px" }}
              >
                {stepsQuantity.map((step, index) => (
                  <option key={index} value={step}>
                    {step}
                  </option>
                ))}
              </select>
            </div>
            <span className="text-muted">
              <p>
                <b>Min order quantity: </b>
                {props.selectedProduct?.pro_minBuy}
                {"           "}
                <b> Max order quantity: </b>
                {props.selectedProduct?.pro_maxBuy}
              </p>
            </span>
          </>
        )}
      </div>

      <div className="flex-grow-1 ms-3">
        <Row>
          <Col lg={4} sm={12}>
            <div className="p-2 border border-dashed rounded">
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-2">
                  <div className="avatar-title rounded bg-transparent text-success fs-24">
                    <i className="ri-money-dollar-circle-fill"></i>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="text-muted mb-1"> Price: </p>
                  <h5 className="mb-0">
                    {formatCurrency(props.selectedProduct?.pro_price)}
                  </h5>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={4} sm={12}>
            <div className="p-2 border border-dashed rounded">
              <div className="d-flex align-items-center">
                <div className="avatar-sm me-2">
                  <div className="avatar-title rounded bg-transparent text-success fs-24">
                    <i className="ri-money-dollar-circle-fill"></i>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <p className="text-muted mb-1"> Total Price: </p>
                  <h5 className="mb-0">
                    {formatCurrency(
                      orderQuantity * props.selectedProduct?.pro_price
                    )}
                  </h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="m-3">
        {props.selectedProduct?.pro_extendedLeadTime &&
          props.selectedProduct?.pro_extendedLeadTime > 0 && (
            <div className="d-flex m-1">
              <i className="ri-time-line me-2 text-danger" />
              <span className="fw-medium text-danger">
                Extended Lead Time:{" "}
                {props.selectedProduct?.pro_extendedLeadTime} days
              </span>
            </div>
          )}
        {props.selectedProduct?.pro_MAP > 0 && (
          <div className="d-flex m-1">
            <i className="ri-price-tag-3-line me-2 text-danger" />
            <span className="text-danger fw-medium">
              This product is subject to minimum advertise pricing of{" "}
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(props.selectedProduct.pro_MAP)}{" "}
              and cannot be sold on any sales channel below this price.
            </span>
          </div>
        )}
        {props.selectedProduct?.pro_importantNotes && (
          <div className="d-flex m-1">
            <span className="text-danger fw-medium">
              <p>
                Important notes: {props.selectedProduct?.pro_importantNotes}
              </p>
            </span>
          </div>
        )}
        {((props.selectedProduct?.pro_MAP &&
          props.selectedProduct?.pro_MAP > 0) ||
          (props.selectedProduct?.pro_extendedLeadTime &&
            props.selectedProduct?.pro_extendedLeadTime > 0) ||
          props.selectedProduct?.pro_importantNotes) && (
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="acknowledgeCheckbox"
              checked={acknowledged}
              onChange={handleAcknowledgement}
            />
            <label className="form-check-label" htmlFor="acknowledgeCheckbox">
              I acknowledge and agree to the above terms and notices.
            </label>
          </div>
        )}
      </div>

      {userProfileSession?.user_stripeDefaultPaymentMethodId == null && (
        <Alert color="danger" className="m-3">
          <div className="d-flex align-items-center">
            <i className="ri-alert-fill fs-20 me-2"></i>
            <div>
              <h5 className="mb-0">Payment Method Required</h5>
              <p className="mb-0">
                You need to add a payment method for purchases to place an
                order.
              </p>

              <button
                type="button"
                className="btn w-sm btn-success "
                id="send-record"
                onClick={() => {
                  navigate("/billing");
                }} // This is the function that will be called when the button is clicked
              >
                Go to billing
              </button>
            </div>
          </div>
        </Alert>
      )}
      {(userProfileSession?.user_sellerCloudCompanyId == null ||
        userProfileSession?.user_sellerCloudCompanyId == 0) && (
        <Alert color="danger" className="m-3">
          <div className="d-flex align-items-center">
            <i className="ri-alert-fill fs-20 me-2"></i>
            <div>
              <h5 className="mb-0">SellerCloud Company ID Required</h5>
              <p className="mb-0">
                You need to set your SellerCloud Company ID under your profile
                to place an order.
              </p>
              <button
                type="button"
                className="btn w-sm btn-success "
                id="send-record"
                onClick={() => {
                  navigate("/profile");
                }} // This is the function that will be called when the button is clicked
              >
                Go to profile
              </button>
            </div>
          </div>
        </Alert>
      )}
      <ModalFooter>
        <Button
          type="button"
          color="secondary"
          onClick={() => setShowPlaceOrder(false)}
        >
          Close
        </Button>

        <Button
          type="button"
          color="primary"
          onClick={() => {
            if (hasFreeTrialPlan) {
              setShowUpgradeModal(true);
            } else {
              setShowConfirm(true);
            }
          }}
          disabled={
            userProfileSession?.user_stripeDefaultPaymentMethodId == null ||
            userProfileSession?.user_sellerCloudCompanyId == null ||
            userProfileSession?.user_sellerCloudCompanyId == 0 ||
            (!acknowledged &&
              ((props.selectedProduct?.pro_MAP &&
                props.selectedProduct?.pro_MAP > 0) ||
                (props.selectedProduct?.pro_extendedLeadTime &&
                  props.selectedProduct?.pro_extendedLeadTime != "0") ||
                props.selectedProduct?.pro_importantNotes))
          }
        >
          Place Order
        </Button>
      </ModalFooter>
    </Modal>
    </>
  );
}

/*
{
  !acknowledged &&
    (props.selectedProduct?.pro_MAP ||
      props.selectedProduct?.pro_extendedLeadTime ||
      props.selectedProduct?.pro_importantNotes);
}
*/
